const IconRoot = '/assets/icon/'
const makePath = (icon: string) => {
    return IconRoot + icon
}

export const UserIcon = makePath('UserIcon.png')

export const BindWxIcon = makePath('BindWxIcon.png')
export const KnowledgeIcon = makePath('KnowledgeIcon.png')
export const MyBotIcon = makePath('MyBotIcon.png')
export const StudyIcon = makePath('StudyIcon.png')
export const HelpIcon = makePath('HelpIcon.png')
export const GroupIcon = makePath('GroupIocn.png')
export const PassShowIcon = makePath('PassShowIcon.png')
export const PassHideIcon = makePath('PassHideIcon.png')
export const ClipIcon = makePath('ClipIcon.png')
export const DeleteDisableIcon = makePath('DeleteDisableIcon.png')
export const AddIcon = makePath('AddIcon.png')
export const ArrowRightIcon = makePath('ArrowRightIcon.png')
export const DeleteableIcon = makePath('DeleteableIcon.png')
export const PlusIcon = makePath('PlusIcon.png')
export const DeleteIcon = makePath('DeleteIcon.png')
export const MergeIcon = makePath('MergeIcon.png')
export const SearchIcon = makePath('SearchIcon.png')
export const SearchGrayIcon = makePath('SearchGrayIcon.png')
export const BotStoreIcon = makePath('BotStoreIcon.png')
export const InputClearIcon = makePath('InputClearIcon.png')
export const ArrowUpIcon = makePath('ArrowUpIcon.png')
export const ArrowDownIcon = makePath('ArrowDownIcon.png')
export const UserBotIcon = makePath('UserBotIcon.png')

export const BotLogoutIcon = makePath('BotLogoutIcon.png')
export const AnswerTextIcon = makePath('AnswerTextIcon.png')
export const AnswerImageIcon = makePath('AnswerImageIcon.png')
export const AnswerCardIcon = makePath('AnswerCardIcon.png')
export const AnswerMiniIcon = makePath('AnswerMiniIcon.png')
export const AnswerFileIcon = makePath('AnswerFileIcon.png')
export const AnswerVideoIcon = makePath('AnswerVideo.png')
export const FileTypeIcon = makePath('FileIcon.png')
export const UploadEditIcon = makePath('UploadEditIcon.png')

export const MpCardGhIcon = makePath('MpCardGhIcon.png')
export const MpCardLogoIcon = makePath('MpCardLogoIcon.png')
export const MpCardAppIcon = makePath('MpCardAppIcon.png')
export const MpCardTitleIcon = makePath('MpCardTitleIcon.png')
export const MpCardPageIcon = makePath('MpCardPageIcon.png')

export const CardTitleIcon = makePath('CardTitleIcon.png')
export const CardDescIcon = makePath('CardDescIcon.png')
export const CardLinkIcon = makePath('CardLinkIcon.png')
export const CardThumbIcon = makePath('CardThumbIcon.png')

export const BotIcon = makePath('BotIcon.png')
export const StatusValidIcon = makePath('StatusValidIcon.png')
export const BackArrowIcon = makePath('BackArrowIcon.png')
export const RadioActiveIcon = makePath('RadioActiveIcon.png')
export const RadioInactiveIcon = makePath('RadioInactiveIcon.png')
export const ContactAddIcon = makePath('ContactAddIcon.png')
export const ContactSubIcon = makePath('ContactSubIcon.png')
export const SelectedIcon = makePath('SelectedIcon.png')

// 敬请期待
export const IdiomIcon = makePath('成语接龙.png')
export const ConfrontationIcon = makePath('对仗游戏.png')
export const LegalIcon = makePath('法律知识库.png')
export const TourismIcon = makePath('旅游景点查询.png')
export const AnswerIcon = makePath('抢答游戏.png')
export const ConstellationIcon = makePath('星座运势.png')
export const HrIcon = makePath('HR助手.png')
